<template>
  <input
    type="file"
    ref="input"
    @change="onChange"
    :multiple="multiple"
    style="opacity: 0; height: 0;width: 0"/>
</template>


<script>
export default {
  props: {
    // Support Multiple File?
    multiple: {
      type: Boolean,
      default: false,
    },
    // Pass the files info when it's done
    done: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    onChange(e) {
      // get the files
      const files = e.target.files;
      // Process each file
      const allFiles = [];
      for (let i = 0; i < files.length; i += 1) {
        const vm = this;
        const file = files[i];
        // Make new FileReader
        const reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);

        reader.onload = () => {
          // Make new image instance
          const image = new Image();
          image.src = reader.result;
          // eslint-disable-next-line
          image.onload = function () { 
            // access image size here
            const fileInfo = {
              name: file.name,
              type: file.type,
              width: this.width,
              height: this.height,
              size: `${Math.round(file.size / 1000)} kB`,
              base64: reader.result,
              file,
            };
            allFiles.push(fileInfo);
            // If all files have been proceed
            if (allFiles.length === files.length) {
              // Apply Callback function
              if (vm.multiple) vm.done(allFiles);
              else vm.done(allFiles[0]);
            }
          };
        };
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UploadBase64.vue